import React, { useEffect } from 'react';
import AsyncWrapper from '@/components/AsyncWrapper';
import { CardEndpoint, requestCardUserList } from '@/models/card';
import { Col, Empty, Row } from 'antd';
import CardUserView from '../Card/CardUser';

export type Props = {
  userId: number;
};

const CardUserList: React.FC<Props> = ({ userId }: Props) => {
  const { payload, send: getCardUserList, loading, error } = requestCardUserList();

  useEffect(() => {
    if (userId) {
      getCardUserList({
        url: `${CardEndpoint}/user/${userId}`,
      }).then();
    }
  }, [userId]);

  return (
    <AsyncWrapper loading={loading} error={error} render={!!payload}>
      {() => {
        const list = payload.list;
        if (!list || !list.length) {
          return <Empty description={'没有套餐卡信息'} />;
        }
        return (
          <Row gutter={[10, 10]}>
            {list.map(cardUser => {
              return (
                <Col span={24} key={cardUser.id}>
                  <CardUserView card={cardUser} />
                </Col>
              );
            })}
          </Row>
        );
      }}
    </AsyncWrapper>
  );
};

export default CardUserList;
